import { Injectable, computed, inject, signal } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

interface Breadcrumb {
  label: string;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsSignal = signal<Breadcrumb[]>([]);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  public readonly breadcrumbs = computed(() => this.breadcrumbsSignal());

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
      this.updateBreadcrumbs(breadcrumbs);
    });

    setTimeout(() => {
      const breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
      this.updateBreadcrumbs(breadcrumbs);
    });
  }

  updateBreadcrumbs(breadcrumbs: Breadcrumb[]): void {
    this.breadcrumbsSignal.set(breadcrumbs);
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    const child = children[0];

    const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
    if (routeURL !== '') {
      url += `/${routeURL}`;
    }

    const label = child.snapshot.data['breadcrumb'];
    if (label) {
      breadcrumbs.push({
        label: label,
        url: url,
      });
    }

    return this.createBreadcrumbs(child, url, breadcrumbs);
  }
}